export type PatientData = {
  patientFirstName: string | null;
  patientLastName: string | null;
  patientDob: string | null;
  patientGender: 'M' | 'F' | null;
  patientPhone: string | null;
  patientAddressCity: string | null;
  patientAddressState: string | null;
  patientAddressZip: string | null;
  patientAddressLine: string | null;
}

export enum IncomingDocumentSource {
  FAX = 'fax',
  EMAIL = 'email',
}

export enum IncomingDocumentStatus {
  NEW = 'NEW',
  PROCESSED = 'PROCESSED',
  MATCHED = 'MATCHED',
  ATTACHED = 'ATTACHED',
  FAILED = 'FAILED',
  SPLIT = 'SPLIT',
}

export type IncomingMailData = {
  sender: string;
  subject?: string | null;
  mailbox: string;
  messageId: string;
  attachmentName: string;
  rawEmailKey?: string | null;
  textBody?: string | null;
}

export enum FaxType {
  RX = "RX",
  AOB = "AOB",
  PAP = "PAP",
  REPORT = "REPORT",
  BILLING_DOC = "BILLING_DOC",
  INSURANCE_AUTH_DOC = "INSURANCE_AUTH_DOC",
  OFFICE_NOTES = 'OFFICE_NOTES',
  RX_OFFICE_NOTES = 'RX_OFFICE_NOTES',
  OTHER = "OTHER"
}

export type IncomingDocumentType = {
  uuid: string;
  mediaUrl: string;
  faxType?: string | null;
  source: IncomingDocumentSource;
  status: IncomingDocumentStatus;
  orderId?: number | null;
  createdAt: string;
  createdAtValue: number;
  patientData: PatientData;
  mailData?: IncomingMailData | null;
  error?: string | null;
}
